export default __webpack_public_path__ + "static/media/az.17c7e7e2.svg";